import CardRowSegment from "components/CardRowSegment/CardRowSegment";
import React from "react";

interface Props {
  billingDetails: server.dto.ClientBillingDetails
}

const AddressRow = (props: Props) => (
  <CardRowSegment className="margin-bottom" type="lined">
    <div>
      <div>
        <strong>{props.billingDetails.company.name}</strong>
      </div>
      <div>
        {props.billingDetails.company.cityCountry}
      </div>
    </div>
  </CardRowSegment>);

export default AddressRow;